export default __webpack_public_path__ + "static/Hero Image-5c4303457a86e4583b9b06663900acdb.webp";